<script lang="ts" setup>
import { propTypes } from "@/utils/propTypes";
import { isNumber } from "@/utils/is";
defineOptions({ name: "Dialog" });

const slots = useSlots();

const props = defineProps({
  modelValue: propTypes.bool.def(false),
  title: propTypes.string.def("Dialog"),
  fullscreen: propTypes.bool.def(false),
  width: propTypes.oneOfType([String, Number]).def("40%"),
  scroll: propTypes.bool.def(false), // 是否开启滚动条。如果是的话，按照 maxHeight 设置最大高度
  maxHeight: propTypes.oneOfType([String, Number]).def("400px"),
});

const getBindValue = computed(() => {
  const delArr: string[] = ["fullscreen", "title", "maxHeight", "appendToBody"];
  const attrs = useAttrs();
  const obj = { ...attrs, ...props };
  for (const key in obj) {
    if (delArr.indexOf(key) !== -1) {
      delete obj[key];
    }
  }
  return obj;
});

const isFullscreen = ref(false);

const toggleFull = () => {
  isFullscreen.value = !unref(isFullscreen);
};

const dialogHeight = ref(isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight);

watch(
  () => isFullscreen.value,
  async (val: boolean) => {
    await nextTick();
    if (val) {
      const windowHeight = document.documentElement.offsetHeight;
      dialogHeight.value = `${windowHeight - 55 - 60 - (slots.footer ? 63 : 0)}px`;
    } else {
      dialogHeight.value = isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight;
    }
  },
  {
    immediate: true,
  },
);

const dialogStyle = computed(() => {
  return {
    height: unref(dialogHeight),
  };
});
</script>

<template>
  <ElDialog
    v-bind="getBindValue"
    :close-on-click-modal="false"
    :fullscreen="isFullscreen"
    :width="width"
    destroy-on-close
    lock-scroll
    draggable
    class="com-dialog"
    :show-close="false"
  >
    <template #header="{ close }">
      <div class="relative h-30px flex items-center justify-between pl-15px pr-15px">
        <slot name="title">
          {{ title }}
        </slot>
        <div class="absolute right-15px top-[50%] h-24px flex translate-y-[-50%] items-center justify-between">
          <Icon
            v-if="fullscreen"
            class="is-hover mr-10px cursor-pointer"
            :icon="isFullscreen ? 'radix-icons:exit-full-screen' : 'radix-icons:enter-full-screen'"
            color="var(--el-color-info)"
            hover-color="var(--el-color-primary)"
            @click="toggleFull"
          />
          <Icon
            class="is-hover cursor-pointer"
            :size="30"
            icon="ep:circle-close"
            hover-color="var(--el-color-primary)"
            color="var(--el-color-info)"
            @click="close"
          />
        </div>
      </div>
    </template>

    <ElScrollbar v-if="scroll" :style="dialogStyle">
      <slot></slot>
    </ElScrollbar>
    <slot v-else></slot>
    <template v-if="slots.footer" #footer>
      <slot name="footer"></slot>
    </template>
  </ElDialog>
</template>

<style lang="scss">
.com-dialog {
  border-radius: 15px;
  --el-dialog-padding-primary: 18px;

  .#{$elNamespace}-overlay-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .#{$elNamespace}-dialog {
    margin: 0 !important;

    &__header {
      height: 42px;
      padding: 0;
      margin-right: 0 !important;
      border-bottom: 2px solid var(--el-border-color);
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__body {
      padding: 0;
    }

    &__footer {
      border-top: 2px solid var(--el-border-color);
      text-align: center;
      .el-button {
        width: 130px;
      }
      .el-button + .el-button {
        margin-left: 20px;
      }
    }

    &__headerbtn {
      top: 0;
    }
  }
}
</style>
